import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import imageBlockSVG from '@plone/volto/components/manage/Blocks/Image/block-image.svg';
import { isInternalURL } from '@plone/volto/helpers';
import { Icon, MaybeWrap } from '@plone/volto/components';
import { UniversalLink } from '@plone/volto/components';
import cx from 'classnames';
import config from '@plone/volto/registry';
import svgRight from '@plone/volto/icons/right-key.svg';
import { useShaveEffect } from './utils';

const messages = defineMessages({
  PleaseChooseContent: {
    id: 'Please choose an existing content as source for this element',
    defaultMessage:
      'Please choose an existing content as source for this element',
  },
});

const TeaserBoxBody = (props) => {
  const { className, data, isEditMode, style } = props;
  const intl = useIntl();
  const href = data.href?.[0];
  const image = data.preview_image?.[0];
  const contentRef = useRef(null);

  const Image = config.getComponent('Image').component;
  const { openExternalLinkInNewTab } = config.settings;

  const teaserImageHref = image ? image?.['@id'] : href?.['@id'];
  const teaserImageScales = image
    ? image.image_scales.image?.[0].scales
    : href?.image_scales?.preview_image?.[0].scales;
  const maxHeight = data?.styles?.boxsize === 'large' ? 280 : 120;

  useShaveEffect(contentRef, maxHeight);

  return (
    <div className={cx('block teaser', className)} style={style}>
      <>
        {!href && isEditMode && (
          <Message>
            <div className="teaser-item placeholder">
              <img src={imageBlockSVG} alt="" />
              <p>{intl.formatMessage(messages.PleaseChooseContent)}</p>
            </div>
          </Message>
        )}
        {href && (
          <MaybeWrap
            condition={!isEditMode}
            as={UniversalLink}
            href={href['@id']}
            target={
              data.openLinkInNewTab ||
              (openExternalLinkInNewTab && !isInternalURL(href['@id']))
                ? '_blank'
                : null
            }
          >
            <div className="teaser-item default" ref={contentRef}>
              {(href.hasPreviewImage || href.image_scales || image) && (
                <div className="image-wrapper">
                  {data?.styles?.boxsize === 'large' ? (
                    <Image
                      item={image || href}
                      imageField={image ? image.image_field : href.image_field}
                      alt=""
                      loading="lazy"
                      responsive={true}
                      srcSet={`
                        ${teaserImageHref + '/' + teaserImageScales?.['teaser']?.['download']} 400w,
                        ${teaserImageHref + '/' + teaserImageScales?.['large']?.['download']} 800w,
                      `}
                      sizes="(max-width: 770px) 750px, 280px"
                    />
                  ) : (
                    <Image
                      item={image || href}
                      imageField={image ? image.image_field : href.image_field}
                      alt=""
                      loading="lazy"
                      responsive={true}
                      srcSet={`
                        ${teaserImageHref + '/' + teaserImageScales?.['preview']?.['download']} 400w,
                        ${teaserImageHref + '/' + teaserImageScales?.['large']?.['download']} 800w,
                      `}
                      sizes="(max-width: 770px) 750px, 280px"
                    />
                  )}
                </div>
              )}
              <div className="content">
                {data?.head_title && (
                  <div className="headline">{data.head_title}</div>
                )}
                <h2>{data?.title}</h2>
                {!data.hide_description && <p className='truncate'>{data?.description}</p>}
              </div>
              <div className="arrow-link">
                <Icon name={svgRight} size="16px" />
              </div>
            </div>
          </MaybeWrap>
        )}
      </>
    </div>
  );
};

TeaserBoxBody.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default TeaserBoxBody;
